// server 
import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import { SBTreeView } from "../../UiComponents/SBTreeView";
import { SBAComboBox, SBADropDown, SBAMultiSelect } from '../../UiComponents/SBADropDown';
import {
  getRMContacts,
  getExpenseCategoryTypes,
  getexpenseCategory,
  getexpenseSubCategories,
  getExpensebyContact,
  insertorupdateContactExpense,
  insertExpenseSubCategory,
  getIncExpContactAssets,
  insertIncExpAsset,
  deleteIncExpAsset
} from "../../../config/apiConfig";
import { sbaAxios } from '../../utils/sbaAxios';
import { SBDatePicker } from '../../UiComponents/SBDatePicker';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import {
  Chart, ChartLegend,
  ChartSeriesLabels, ChartTitle, ChartCategoryAxis, ChartCategoryAxisItem, ChartValueAxis, ChartTooltip,ChartValueAxisItem, ChartSeries, ChartSeriesItem
} from '@progress/kendo-react-charts';
import { Modal } from "react-bootstrap";
import { LoadingScreen } from '../../UiComponents/LoadingComponent';
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { SBNotify } from "../../utils/sbNotify";
import { CurrencyFormat } from "../../utils/currencyFormattter";



export const ContactExpensesTab = () => {
  const [contactList, setContactList] = useState([]);
  const [selectedContact, setSelectedContact] = useState({});
  const [yearsList, setYearsList] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [showDrawer, setshowDrawer] = useState(false);
  const [categoryTypes, setCategoryTypes] = useState([]);
  const [selectedCategoryType, setSelectedCategoryType] = useState(null);
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subcategory, setsubCategory] = useState([]);
  const [selectedsubCategory, setSelectedsubCategory] = useState(null);
  const [expenseYear, setExpenseYear] = useState();
const [expenseyrdt, setexpenseyrdt] = useState([]);
const [inLineSaveDS, setInLineSaveDS] = useState(-1);
const [typedYear, setTypedYear] = useState(0);
const [isCustomYear, setIsCustomYear] = useState(false);
const [typedExpenseYear, setTypedExpenseYear] = useState(0);
const [isCustomExpenseYear, setIsCustomExpenseYear] = useState(false);
const [drawerMode, setDrawerMode] = useState("");
const [incExpAssets, setIncExpAssets] = useState([]);
const [assetTreeData, setAssetTreeData] = useState([]);

  const [chartData ,setChartData] = useState(null);
  const yeargriddata = [,
    {
      "Month": 'Jan',
      "Amount": ""
    }, {
      "Month": 'Feb',
      "Amount": ""
    },
    {
      "Month": 'March',
      "Amount": ""
    },
    {
      "Month": 'Apr',
      "Amount": ""
    },
    {
      "Month": 'May',
      "Amount": ""
    },
    {
      "Month": 'June',
      "Amount": ""
    }, {
      "Month": 'Jul',
      "Amount": ""
    },
    {
      "Month": 'Aug',
      "Amount": ""
    },
    {
      "Month": 'Sep',
      "Amount": ""
    },
    {
      "Month": 'Oct',
      "Amount": ""
    },
    {
      "Month": 'Nov',
      "Amount": ""
    },
    {
      "Month": 'Dec',
      "Amount": ""
    }
  ]
  const [yeargriddt, setYeargriddt] = useState(yeargriddata);
  const [expenseRowData, setExpenseRowData] = useState([]);
  const [incomeRowData, setIncomeRowData] = useState([]);
  const [totalRowData, setTotalRowData] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [editModel, setEditModel] = useState(false);
  const [expenseSubCatName, setExpenseSubCatName] = useState(null);
  const isMounted = useRef(false);

  useEffect(()=>{
    if(yearsList.length>0){
      setSelectedYear(yearsList[yearsList.length-1]);
      setExpenseYear(yearsList[yearsList.length-1]);
    }
  }, [yearsList]);

  useEffect(()=> {
    if(!showDrawer){
      setDrawerMode("");
      setAssetTreeData([]);
      setIncExpAssets([]);
    }
  },[showDrawer]);

  const transformData = (data) => {
    const treeMap = {};
  
    data.forEach((item) => {
      if (!treeMap[item.PortfolioId]) {
        treeMap[item.PortfolioId] = {
          id: item.PortfolioId,
          text: item.PortfolioName,
          expanded: true, // Default expanded
          checked: false, // Initially unchecked, will be updated dynamically
          items: [],
        };
      }
  
      treeMap[item.PortfolioId].items.push({
        id: item.AssetId,
        text: item.AssetName,
        checked: item.IsIncluded, // Check if IsIncluded is true
      });
    });
  
    // Update parent checked state based on children
    return Object.values(treeMap).map(parent => ({
      ...parent,
      checked: parent.items.length > 0 && parent.items.every(child => child.checked),
    }));
  };

  const fetchIncExpContactAssets = async() =>{
    if(!selectedContact.ContactId){
      toast.error('Please select a Contact!');
    }
    else{
      try{
        const list = await sbaAxios({
          url: `${getIncExpContactAssets}/${selectedContact.ContactId},${selectedCategoryType.IncExpCategoryTypeId}`
        });
        setIncExpAssets(list);
        setAssetTreeData(transformData(list));
      }
      catch(e){
        setIncExpAssets([]);
        setAssetTreeData([]);
      }
    }
  };

  useEffect(()=>{
    if(drawerMode === "AssetSelection" && selectedCategoryType){
      fetchIncExpContactAssets();
    }
  },[selectedCategoryType, drawerMode]);

  const handleExpandChange = (e) => {
    setAssetTreeData((prevData) =>
      prevData.map((item) =>
        item.id === e.item.id ? { ...item, expanded: !e.item.expanded } : item
      )
    );
  };
  
  // Handle Check Change
  const handleCheckChange = async (e) => {
    const isChild = !e.item.items; // True if it's a child (asset), false if it's a parent (portfolio)
  const newCheckedState = !e.item.checked; // The new state after the click

  setAssetTreeData((prevData) => {
    const toggleChecked = (items) => {
      return items.map((item) => {
        if (item.id === e.item.id) {
          return { ...item, checked: newCheckedState };
        } else if (item.items) {
          return { ...item, items: toggleChecked(item.items) };
        }
        return item;
      });
    };
    return toggleChecked(prevData);
  });

  // API Call only for child items (assets)
  if (isChild) {
    if (newCheckedState) {
      // If checked, make the insert API call
      const parentPortfolio = assetTreeData.find((p) =>
        p.items.some((child) => child.id === e.item.id)
      );

      if (parentPortfolio) {
        const requestData = {
          contactId: selectedContact.ContactId,
          portfolioId: parentPortfolio.id,
          assetId: e.item.id,
          categoryTypeId: selectedCategoryType.IncExpCategoryTypeId,
        };

        try {
          await sbaAxios({
            url:insertIncExpAsset,
            method:'post',
            data:requestData
          });
          toast.success('Asset inserted successfully.');
        } catch (error) {
          toast.error('Unable to insert Asset.')
        }
      }
    } else {
      // If unchecked, make the delete API call
      try {
        const incExpAsset = incExpAssets.find((itemObj) => itemObj.AssetId === e.item.id);
        await sbaAxios({
          url: `${deleteIncExpAsset}/${incExpAsset.IncExpInclAssetId}`
        });
        toast.success('Asset removed successfully.')
      } catch (error) {
        toast.error('Unable to remove Asset.')
      }
    }
  }
  };

  const handleFilterChange = (e, comboBoxValue) => {
    const input = e.filter?.value?.trim();
  
    if (input && /^(19\d{2}|20\d{2})$/.test(input)) {
      const yearObj = { yearId: parseInt(input, 10), year: parseInt(input, 10) };
      if(comboBoxValue === "Year"){
        setTypedYear(yearObj.year);
        setSelectedYear(yearObj);  // Set as object to prevent UI reset
        setIsCustomYear(true);
      }
      if(comboBoxValue === "expenseYear"){
        setTypedExpenseYear(yearObj.year);
        setExpenseYear(yearObj);  // Set as object to prevent UI reset
        setIsCustomExpenseYear(true);
      }
    }
  };

  const removeDrawerTabIndex = () => {
    const drawers = document.getElementsByClassName('rs-drawer-wrapper');
    Array.from(drawers).forEach(drawer => {
      drawer.removeAttribute('tabIndex');
    });
  };
  removeDrawerTabIndex();

  const rowTotalSetter = (data) => {
    const row = [];
    row.push(data.TotalIncome);
    row.push(data.TotalExpenses);
    row.push(data.NetMonthlyTotal);

    setTotalRowData(row);
  }

  const fetchContacts = async (searchValue) => {
    try {
      const list = await sbaAxios({
        url: getRMContacts,
        params: {
          searchText: searchValue
        }
      });
      setContactList(list);
    }
    catch (e) {
      setContactList([]);
    }
  };

  const autoGroupColumnDef = {
    headerName: "",
    minWidth: 250,
    cellRendererParams: {
      suppressCount: true,
    },
  };

  const generateYearList = () => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 20; // Last 20 years including current year
    const years = [];

    for (let year = startYear; year <= currentYear; year++) {
      years.push({ yearId: year, year });
    }

    setYearsList(years);
  };
  const fetchContactExpense = async () => {
    const yearValue = isCustomYear? typedYear: selectedYear?.year;
    try {
      const response = await sbaAxios({
        url: getExpensebyContact + `${selectedContact.ContactId},${yearValue}`
      });
      //console.log('expense response: ' , reponse);
      setExpenseRowData(response.Expenses);
      setIncomeRowData(response.Income);
      setChartData(response);
      rowTotalSetter(response);
    }
    catch (e) {
      setExpenseRowData([]);
      setIncomeRowData([])
      //setChartData([]);
    }
  };

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      generateYearList();
      getCategoryType();
    }
    fetchContacts('');
  }, []);

  useEffect(() => {
    if(selectedCategoryType){
      getExpenseCategories();
    }
  },[selectedCategoryType]);

  const getCategoryType = async () => {
    try {
      const list = await sbaAxios({
        url: getExpenseCategoryTypes,
      });
      setCategoryTypes(list);
    }
    catch (e) {
      setCategoryTypes([]);
    }
  };

  const getExpenseCategories = async () => {
    try {
      const list = await sbaAxios({
        url: getexpenseCategory+`/${selectedCategoryType.IncExpCategoryTypeId}`,
      });
      setCategory(list);
    }
    catch (e) {
      setCategory([]);
    }
  };

  const getExpenseSubCategory = async (Id) => {
    try {
      const list = await sbaAxios({
        url: `${getexpenseSubCategories}${Id},${selectedContact?.ContactId}`,
      });
      setsubCategory(list);
    }
    catch (e) {
      setsubCategory([]);
    }
  };
  // Memoized master column definitions
  const getMasterColumnDefs = useMemo(() => {
    const yearValue = isCustomYear? typedYear: selectedYear?.year;
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    const yearString = yearValue?.toString() || "";
    const monthColumns = months.map((month) => ({
      headerName: `${month}'${yearString.slice(-2)}`,
      field: month,
      editable: false,
      valueFormatter: (e) => CurrencyFormat(e.value, 0),
      headerClass: "text-end",
      cellClass: "text-end",
      maxWidth:150,
    }));

    return [
      { headerName: "Category", field: "IncExpCategoryName", pinned: "left", editable: false, cellRenderer: "agGroupCellRenderer" },
      {
        headerName: "Total", field: "Total", pinned: "right", editable: false, headerClass: "text-end",
        cellClass: "text-end", valueFormatter: (e) => CurrencyFormat(e.value, 0), minWidth:100
      },
      ...monthColumns,
    ];
  }, [selectedYear?.year, typedYear]);

  const getMasterColumnDefs_I = useMemo(() => {
    const yearValue = isCustomYear? typedYear: selectedYear?.year;
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    const yearString = yearValue?.toString() || "";
    const monthColumns = months.map((month) => ({
      headerName: `${month}'${yearString.slice(-2)}`,
      field: month,
      editable: false,
      valueFormatter: (e) => CurrencyFormat(e.value, 0),
      headerClass: "text-end",
      cellClass: "text-end",
      maxWidth:150,
    }));

    return [
      { headerName: "Category", field: "IncExpCategoryName", pinned: "left", editable: false, cellRenderer: "agGroupCellRenderer" },
      {
        headerName: "Total", field: "Total", pinned: "right", editable: false, headerClass: "text-end",
        cellClass: "text-end", valueFormatter: (e) => CurrencyFormat(e.value, 0), minWidth:100
      },
      ...monthColumns,
    ];
  }, [selectedYear?.year, typedYear]);

  // Memoized detail column definitions
  const getDetailColumnDefs = useMemo(() => {
    const yearValue = isCustomYear? typedYear: selectedYear?.year;
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    const yearString = yearValue?.toString() || "";
    const monthColumns = months.map((month) => ({
      headerName: `${month}'${yearString.slice(-2)}`,
      field: month,
      editable: (params) => !params.data?.IsReadOnly,
      valueFormatter: (e) => CurrencyFormat(e.value, 0),
      headerClass: "text-end",
      cellClass: "text-end",
      maxWidth:175,
      onCellValueChanged:(e)=>{ 
        if (!e.data?.IsReadOnly)
        {inLineSaveSubExpenseData(e.data,e.column.colId,e)}
      }
    }));

    return [
      { headerName: "Sub Category", field: "IncExpSubCategoryName", pinned: "left", editable: false },
      {
        headerName: "Total", field: "Total", pinned: "right", editable: false, headerClass: "text-end",
        cellClass: "text-end", valueFormatter: (e) => CurrencyFormat(e.value, 0), minWidth:100
      },
      ...monthColumns,
    ];
  }, [selectedYear?.year, typedYear]);

  const getDetailColumnDefs_I = useMemo(() => {
    const yearValue = isCustomYear? typedYear: selectedYear?.year;
    const months = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
    const yearString = yearValue?.toString() || "";
    const monthColumns = months.map((month) => ({
      headerName: `${month}'${yearString.slice(-2)}`,
      field: month,
      editable: (params) => !params.data?.IsReadOnly,
      valueFormatter: (e) => CurrencyFormat(e.value, 0),
      headerClass: "text-end",
      cellClass: "text-end",
      maxWidth:150,
      onCellValueChanged:(e)=>{
        if (!e.data?.IsReadOnly) 
        {inLineSaveSubExpenseData(e.data,e.column.colId,e)}
      }
    }));

    return [
      { headerName: "Sub Category", field: "IncExpSubCategoryName", pinned: "left", editable: false },
      {
        headerName: "Total", field: "Total", pinned: "right", editable: false, headerClass: "text-end",
        cellClass: "text-end", valueFormatter: (e) => CurrencyFormat(e.value, 0), minWidth:100
      },
      ...monthColumns,
    ];
  }, [selectedYear?.year, typedYear]);

  // Memoized detail parameters
  const detailCellRendererParams = useMemo(
    () => ({
      detailGridOptions: {
        columnDefs: getDetailColumnDefs,
        defaultColDef: {
          resizable: true,
          sortable: true,
          filter: true,
          flex:1
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data?.IncExpBySubCatAndMonths || []);
      },
    }),
    [getDetailColumnDefs]
  );

  const detailCellRendererParams_I = useMemo(
    () => ({
      detailGridOptions: {
        columnDefs: getDetailColumnDefs_I,
        defaultColDef: {
          resizable: true,
          sortable: true,
          filter: true,
          flex:1
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data?.IncExpBySubCatAndMonths || []);
      },
    }),
    [getDetailColumnDefs_I]
  );


  const labelTemplate = e => e.category + "\n" + e.value + "%";

  const opendrawerpoup = () => {
    setDrawerMode("AddRow")
    setshowDrawer(true);
    setSelectedCategoryType(null);
    setSelectedCategory(null);
    setSelectedsubCategory(null);
    setYeargriddt(yeargriddata);
    setexpenseyrdt([]);
  }

  const handleAssetSelectionClick = () => {
    setDrawerMode("AssetSelection");
    setshowDrawer(true);
    setSelectedCategoryType(null);
  }
  const Categorycmbchange = (e) => {
    if (e.value) {
      setSelectedCategory(e.value);
      getExpenseSubCategory(e.value.IncExpCategoryId);
    }
  }

  const YearcolDef = [
    { headerName: 'Month', field: 'Month', resizable: true, maxWidth: 200 },
    { headerName: 'Amount', field: 'Amount',valueFormatter: (e) => CurrencyFormat(e.value, 0) , resizable: true, editable: true, flex: 1 },
  ];

  const fillColumnValues = (api, column, rowIndex, value) => {
    const lastRowIndex = api.getDisplayedRowCount() - 1;
    if (rowIndex < lastRowIndex) {
      for (let i = rowIndex + 1; i <= lastRowIndex; i++) {
        api.getRowNode(i).setDataValue(column, value);
      }
    }
  };

  const getContextMenuItems = (params) => {
    // Default context menu items including the built-in ones and custom items if any
    const defaultItems = params.defaultItems || [];
  
    // Add custom item to the context menu
    const customItems = [
      {
        name: 'Auto Fill Rows',
        disabled: params.node.rowIndex === params.api.getDisplayedRowCount() - 1, // Disable if in last row
        action: () => {
          const value = params.value;
          const column = params.column.getColId();
          const rowIndex = params.node.rowIndex;
          fillColumnValues(params.api, column, rowIndex, value);
        },
      },
    ];
  
    // Return combined list of default context menu items and custom item
    //return [...defaultItems, 'separator', ...customItems];
    return [...customItems];
  };

  const onCellValueChanged = (params) => {
    setYeargriddt((prevData) =>
      prevData.map((item) => {
        if (item.Month === params.data.Month) {
          return {
            ...item,
            Amount: params.data.Amount,
          };
        }
        return item;
      })
    );
    // Add a new object to the expenseyrdt array immutably
    setexpenseyrdt((prevExpenseyrdt) => [
      ...prevExpenseyrdt,
      { Month: params.data.Month, Amount: params.data.Amount },
    ]);
  };

  const insertorupdateExpense = () => {
    console.log('selected sub category', selectedsubCategory);
    let ifsave = true;
    if (selectedContact.ContactId == 0 || selectedContact.ContactId == "" || selectedContact.ContactId == null) {
      SBNotify({ Msg: "Please Select Contact", type: "error" });
      ifsave = false;

      return;
    }
    if (!selectedCategory) {
      SBNotify({ Msg: "Please Select Category", type: "error" });
      ifsave = false;

      return;
    }
    if (!selectedsubCategory) {
      SBNotify({ Msg: "Please Select Sub Category", type: "error" });
      ifsave = false;

      return;
    }
    // const data={
    //   ContactId: selectedContact.ContactId || 0,
    //   ExpenseSubCategoryId: selectedsubCategory.ExpenseSubCategoryId || 0,
    //   ExpenseYear: expenseYear.year ,
    //   MonthAbrev: expenseyrdt.Month ,
    //   ExpenseAmount: expenseyrdt.Amount , 
    // }

    const data = expenseyrdt.map((item) => {
      const yearValue = isCustomExpenseYear? typedExpenseYear: expenseYear.year;
      return {
        contactId: selectedContact.ContactId || 0,
        incExpSubCategoryId: selectedsubCategory.IncExpSubCategoryId || 0,
        incExpYear: yearValue,
        monthAbrev: item.Month,
        incExpAmount: item.Amount,
      }
    })
    if (ifsave) {
      sbaAxios({
        url: `${insertorupdateContactExpense}`,
        method: "post",
        data: data,
      })
        .then(async (response) => {
          if (response) {
            SBNotify({
              type: "success",
              Msg: "Contact Expense saved Successfully",
            });
            setshowDrawer(false);
            fetchContactExpense();
          } else {
            SBNotify({
              type: "error",
              Msg: `Failed to Update`,
            });
          }
        })
        .catch(() => { });
    }
  };
  const girdRef = useRef();
  const [expandAll, setExpandAll] = useState(false);

  const inLineSaveSubExpenseData=async (data,columnName,e)=>{
    console.log('incoming data: ', data);
    const dataToSave = [
      {
        "contactId": data.ContactId,
        "incExpSubCategoryId": data.IncExpSubCategoryId,
        "incExpYear": data.IncExpYear,
        "monthAbrev": columnName,
        "incExpAmount": data[columnName]
    }
    ]

    try{
      await sbaAxios({
        url:insertorupdateContactExpense,
        data:dataToSave,
        method:"post"
      });
      toast.success('Contact Expense saved Successfully')
    }
    catch(e){
      toast.error('Failed to Update.')
    }
    finally{
      const list = await sbaAxios({
        url: getExpensebyContact + `${data?.ContactId},${data?.IncExpYear}`
      });
      setExpenseRowData(list.Expenses);
      setIncomeRowData(list.Income);
      rowTotalSetter(list);
    }
  };
  const onFirstDataRendered = useCallback((params) => {
    setTimeout(() => {
      if(inLineSaveDS>-1)
      {
        params.api.getDisplayedRowAtIndex(inLineSaveDS).setExpanded(true);
      }
    }, 0);
  }, []);

  const handleInsertExpenseSubCat = async() => {
    if(expenseSubCatName === null || expenseSubCatName === ""){
      toast.error('Enter the Expense Subcategory Name.')
      return
    }
    if(!selectedCategory?.IncExpCategoryId){
      toast.error('Select an Expense Category')
      return
    }
    if(!selectedContact?.ContactId){
      toast.error('Select a Contact');
      return
    }
    try{
      const data = {
        contactId: selectedContact?.ContactId,
        incExpSubCategoryId: editModel ? selectedsubCategory?.IncExpSubCategoryId : 0,
        incExpSubCategoryName: expenseSubCatName,
        incExpCategoryId: selectedCategory?.IncExpCategoryId
      }
      await sbaAxios({
        url:insertExpenseSubCategory,
        data:data,
        method:'post'
      });
      toast.success('Expense Subcategory Added successfully');
    }
    catch(e){
      toast.error('Unable to add Expense Subcategory.');
    }
    finally{
      getExpenseSubCategory(selectedCategory?.IncExpCategoryId);
      setShowModel(false);
      setExpenseSubCatName("");
      setEditModel(false);
      setSelectedsubCategory(subcategory.filter((item) => item.IncExpSubCategoryId === selectedsubCategory?.IncExpSubCategoryId));
    }
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-4">
            <div className='row'>
              <div className='col'>
                <label className='label'>Contact</label>
                <div>
                  <SBAComboBox
                    className="w-75"
                    data={contactList}
                    textField={"ContactName"}
                    valueField={"ContactId"}
                    value={selectedContact}
                    onChange={(e) => { setSelectedContact(e.value) }}
                    // onFilterChange={(e) => {
                    //   //setSearchValue(e.filter?.value || "");
                    //   // fetchContacts(e.filter?.value || "")
                    // }}
                    popupSettings={{ className: "modalDD" }}
                  ></SBAComboBox>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col'>
                <div style={{ flex: 1 }}>
                  <label className='label'>Year</label>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}>
                    <SBAComboBox
                      className="w-75"
                      data={yearsList}
                      textField={"year"}
                      valueField={"yearId"}
                      value={selectedYear}
                      onFilterChange={(e)=>{
                        handleFilterChange(e, 'Year');
                      }}
                      onChange={(e) => {
                        if(e.value){
                          setSelectedYear(e.value)
                          setIsCustomYear(false)
                        }
                      }}
                      popupSettings={{ className: "modalDD" }}
                    ></SBAComboBox>
                    <button
                      type="submit"
                      className="p-sm-btn"
                      onClick={() => {
                        fetchContactExpense();
                      }}
                    >
                      Go
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-8">
            <div className="row"  style={{ position: "relative" }}>
              <div className="col-6"  style={{ paddingRight: "16px", borderRight: "1px solid #ccc" }}>
              {chartData?.Expenses?.length>0?<ExpenseChart ChartData={chartData} labelTemplate={labelTemplate}></ExpenseChart>:<div
          style={{
            textAlign: "center",
            padding: "20px",
            fontSize: "16px",
            color: "#888",
            border: "1px dashed #ccc",
            borderRadius: "8px",
            background: "#f9f9f9",
            height:"300px",
            width:"100%"
          }}
        >
          No data available for Chart.
        </div>}

              </div>
              <div className="col-6"  style={{ paddingLeft: "16px" }}>
                     
        {chartData?.Expenses?.length>0?<TimeSeriesChart ChartData={chartData} labelTemplate={labelTemplate}></TimeSeriesChart>:<div
          style={{
            textAlign: "center",
            padding: "20px",
            fontSize: "16px",
            color: "#888",
            border: "1px dashed #ccc",
            borderRadius: "8px",
            background: "#f9f9f9",
            height:"300px",
            width:"100%"
          }}
        >
          No data available for Chart.
        </div>}
              </div>
            </div>
     
        

          </div>
        </div>
        <div className="row mt-8">
          <div className="d-flex justify-content-end gap-2">
            <button className='p-sm-btn mb-2' onClick={() => { setExpandAll(!expandAll) }}>{expandAll ? "Collapse All" : "Expand All"}</button>

            <button className='p-sm-btn mb-2' onClick={()=>{opendrawerpoup()}}>Add Row</button>
            <button className='p-sm-btn mb-2' onClick={()=>{handleAssetSelectionClick()}}>Select Assets</button>
          </div>
        </div>
        <div className="row mt-2">
          <strong>Income:</strong>
        <div
            className="ag-theme-alpine"
            style={{ height: "300px", width: "100%", paddingTop: 0 }}
            key={expandAll ? 1 : 2}
          >
            <AgGridReact
              rowData={incomeRowData}
              columnDefs={getMasterColumnDefs_I}
              defaultColDef={{ resizable: true, sortable: true, filter: true ,flex:1}}
              masterDetail={true}
              autoGroupColumnDef={autoGroupColumnDef}
              getRowNodeId={(data) => data.IncExpCategoryId}
              detailCellRendererParams={detailCellRendererParams_I}
              groupDefaultExpanded={expandAll ? -1 : 0}
              suppressScrollOnNewData={true}
              suppressExpandablePivotGroups={true}
              //onFirstDataRendered={onFirstDataRendered}
            />
          </div>
        </div>
        <div className="row mt-2">
          <strong>Expense:</strong>
        <div
            className="ag-theme-alpine"
            style={{ height: "300px", width: "100%", paddingTop: 0 }}
            key={expandAll ? 1 : 2}
          >
            <AgGridReact
              rowData={expenseRowData}
              columnDefs={getMasterColumnDefs}
              defaultColDef={{ resizable: true, sortable: true, filter: true ,flex:1}}
              masterDetail={true}
              autoGroupColumnDef={autoGroupColumnDef}
              getRowNodeId={(data) => data.IncExpCategoryId}
              detailCellRendererParams={detailCellRendererParams}
              groupDefaultExpanded={expandAll ? -1 : 0}
              suppressScrollOnNewData={true}
              suppressExpandablePivotGroups={true}
              //onFirstDataRendered={onFirstDataRendered}
            />
          </div>
        </div>
        <div className="row mt-2">
          <strong>Total:</strong>
        <div
            className="ag-theme-alpine"
            style={{ height: "200px", width: "100%", paddingTop: 0 }}
          >
            <AgGridReact
              rowData={totalRowData}
              columnDefs={getMasterColumnDefs}
              defaultColDef={{ resizable: true, sortable: true, filter: true ,flex:1}}
              //onFirstDataRendered={onFirstDataRendered}
            />
          </div>
        </div>
      </div>

      <SBADrawer
        open={showDrawer}
        setOpen={setshowDrawer}
        close={false}
        title={drawerMode === "AddRow"?"Add Income/Expenses": "Select Assets"}
        style={{ width: "40vw" }}
      >
        {drawerMode === "AddRow" && 
        <>
          <div className="row">
          <div className='col'>
            <label className='label'>Category Type<span class="mandatory">*</span></label>
            <div>
              <SBAComboBox
                className="w-50"
                data={categoryTypes}
                textField={"IncExpCategoryTypeName"}
                valueField={"IncExpCategoryTypeId"}
                value={selectedCategoryType}
                onChange={(e) => setSelectedCategoryType(e.value)}
                popupSettings={{ className: "modalDD" }}
              ></SBAComboBox>
            </div>
          </div>
        </div>
        <div className="row">
          <div className='col'>
            <label className='label'>Category<span class="mandatory">*</span></label>
            <div>
              <SBAComboBox
                className="w-50"
                data={category}
                textField={"IncExpCategoryName"}
                valueField={"IncExpCategoryId"}
                value={selectedCategory}
                onChange={(e) => { Categorycmbchange(e) }}
                popupSettings={{ className: "modalDD" }}
              ></SBAComboBox>
            </div>
          </div>
        </div>
        <div className="row">
          <div className='col'>
            <div style={{flex:1}}>
            <label className='label'>Sub Category<span class="mandatory">*</span></label>
            <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
            }}>
              <SBAComboBox
                className="w-50"
                data={subcategory}
                textField={"IncExpSubCategoryName"}
                valueField={"IncExpSubCategoryId"}
                value={selectedsubCategory}
                onChange={(e) => { setSelectedsubCategory(e.value) }}
                popupSettings={{ className: "modalDD" }}
                itemRender={(li, itemProps) => {
                  const { dataItem } = itemProps;
                  // Check if ContactId is not zero and append the custom class
                  const isSpecial = dataItem.ContactId !== 0;
                  const additionalClass = isSpecial ? "mapped-entry" : "";
                  
                  return React.cloneElement(li, {
                    className: `${li.props.className || ""} ${additionalClass}`,
                  });
                }}
              ></SBAComboBox>
              <i class="fa-solid fa-add  text-success SBA_hand"  onClick={() => {setShowModel(true)}} title="Add"></i>
              {selectedsubCategory?.ContactId > 0? 
              <i className="fa-solid fa-edit text-success SBA_hand" onClick={() => {setEditModel(true); setExpenseSubCatName(selectedsubCategory?.IncExpSubCategoryName)}} title="Edit"></i>:
              <></>
              }
              {/* <button
                  type="submit"
                  className="p-sm-btn"
                  onClick={() => {setShowModel(true)}}
                >
                  <i className="fa-solid fa-plus" /> Add
                </button> */}
            </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className='col'>
            <label className='label'>Year</label>
            <div>
              <SBAComboBox
                className="w-50"
                data={yearsList}
                textField={"year"}
                valueField={"yearId"}
                value={expenseYear}
                onFilterChange={(e)=>{
                  handleFilterChange(e, "expenseYear");
                }}
                onChange={(e) => { 
                  if(e.value) {
                  setExpenseYear(e.value)
                  isCustomExpenseYear(false);
                  }
                }}
                popupSettings={{ className: "modalDD" }}
              ></SBAComboBox>
            </div>
          </div>
        </div>
        <div>
          <div className="ag-theme-alpine" style={{ height: "50vh" }}>
            <AgGridReact suppressScrollOnNewData={true} rowData={yeargriddt} columnDefs={YearcolDef} onCellValueChanged={onCellValueChanged} getContextMenuItems={getContextMenuItems} defaultColDef={{resizable:true}}></AgGridReact>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-4 ms-auto">
            <div className="d-flex justify-content-end gap-2">
              <button className="p-sm-btn mx-1" onClick={insertorupdateExpense}>
                Save
              </button>
              <button className="s-sm-btn mx-1" onClick={() => {
                setshowDrawer(false);
              }}>Cancel</button>
            </div>
          </div>
        </div>
        </>}
        {drawerMode === "AssetSelection" && 
        <>
        <div className="row">
          <div className='col'>
            <label className='label'>Category Type<span class="mandatory">*</span></label>
            <div>
              <SBAComboBox
                className="w-50"
                data={categoryTypes}
                textField={"IncExpCategoryTypeName"}
                valueField={"IncExpCategoryTypeId"}
                value={selectedCategoryType}
                onChange={(e) => setSelectedCategoryType(e.value)}
                popupSettings={{ className: "modalDD" }}
              ></SBAComboBox>
            </div>
          </div>
        </div>
        {assetTreeData.length>0 ?
        <div className="row mt-2">
          <div className="col">
            <label className="label">Assets</label>
            <div>
            <SBTreeView 
              data={assetTreeData} 
              expandIcons={true} 
              checkboxes={true} 
              onExpandChange={handleExpandChange}  // <-- Expand Fix
              onCheckChange={handleCheckChange}    // <-- Checkbox Fix
            />
            </div>
          </div>
        </div>
        :
        <div className="row mt-2">
          <div className="col">
            <label className="label">
              No Data Available
            </label>
          </div>
        </div>
        }
        </>
        }
      </SBADrawer>
      <Modal show={showModel} onHide={() => {setShowModel(false); setExpenseSubCatName("")}}>
          <Modal.Header closeButton>
            <Modal.Title>Add Expense Sub Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col">
              <label className="label">Expense Sub Category Name:</label>
              <input
                type="text"
                className="input-default form-control"
                name="expenseSubCat"
                value={expenseSubCatName}
                onChange={(e)=> setExpenseSubCatName(e.target.value)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={() => {setShowModel(false); setExpenseSubCatName("")}}>
              Cancel
            </button>
            <button
              className="p-sm-btn mx-1"
              onClick={handleInsertExpenseSubCat}
            >
              Add
            </button>
          </Modal.Footer>
        </Modal>
        <Modal show={editModel} onHide={() => {setEditModel(false); ; setExpenseSubCatName("")}}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Expense Sub Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col">
              <label className="label">Expense Sub Category Name:</label>
              <input
                type="text"
                className="input-default form-control"
                name="expenseSubCat"
                value={expenseSubCatName}
                onChange={(e)=> setExpenseSubCatName(e.target.value)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={() => {setEditModel(false); setExpenseSubCatName("")}}>
              Cancel
            </button>
            <button
              className="p-sm-btn mx-1"
              onClick={handleInsertExpenseSubCat}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
      <ToastContainer></ToastContainer>
    </>

  );
}

export const ExpenseChart = ({ ChartData, labelTemplate }) => {
  const [classifyButtonIndex, setClassifyButtonIndex] = useState(0);
  const [chart, setChart] = useState([]);


  const ClassificationButtons = [
    {
      buttonName: 'Income',
      buttonValue: 0
    },
    {
      buttonName: 'Expense',
      buttonValue: 1
    },
    {
      buttonName: 'Total',
      buttonValue: 2
    }
  ];
  const classifyButtonClick = (index, buttonId) => {
    setClassifyButtonIndex(index);
  };

  const ClasifyButtons = ({ selectedIndex }) => {
    return (
      <>
        <div className="header-container front">
          <div className="button-container">
            {ClassificationButtons.map((button, index) => (
              <button
                key={index}
                className={selectedIndex === index ? "selected-non-gappable-button p-2" : "non gappable-button p-2"}
                onClick={() => {
                  classifyButtonClick(index, button.buttonValue);
                }}
              >
                {button.buttonName}
              </button>

            ))}
          </div>
        </div>
      </>
    )
  };
  useEffect(() => {
    let data = [];
    if (classifyButtonIndex === 0) {
      data = ChartData?.Income || [];
    } else if (classifyButtonIndex === 1) {
      data = ChartData?.Expenses || [];
    } else if (classifyButtonIndex === 2) {
      const row = [];
      row.push(ChartData?.TotalIncome);
      row.push(ChartData?.TotalExpenses);
      data = row.filter(Boolean); // Remove undefined values
    }
  
    // Calculate the total sum of the "Total" property
    const totalSum = data.reduce((acc, item) => acc + item.Total, 0);
  
    // Map through the data to calculate the percentage for each entry
    const processedData = data
      .map((item) => ({
        ...item,
        Percentage: ((item.Total / totalSum) * 100).toFixed(2), // Calculate percentage and format to 2 decimal places
      }))
      .filter((item) => item.Percentage > 0); // Filter out entries with zero percentage
  
    // Handle chart colors based on classifyButtonIndex
    const processChartDataWithColors = async () => {
      if (classifyButtonIndex === 2) {
        // Hardcoded colors for Total Income and Total Expenses
        const coloredData = processedData.map((item) => {
          let color = "#cccccc"; // Default color
          if (item.IncExpCategoryName === "Total Income") {
            color = "#ff8200";
          } else if (item.IncExpCategoryName === "Total Expenses") {
            color = "#677f91"; 
          }
          return { ...item, IncExpChartColor: color };
        });
        setChart(coloredData);
      } else {
        // API call for other classifications
        try {
          const colorResponse = await sbaAxios({
            url: getexpenseCategory + `/${classifyButtonIndex + 1}`,
          });
  
          const coloredData = processedData.map((item) => {
            // Match the category ID and assign the color
            const colorItem = colorResponse.find(
              (color) => color.IncExpCategoryId === item.IncExpCategoryId
            );
            return {
              ...item,
              IncExpChartColor: colorItem?.IncExpChartColor || "#cccccc", // Default color if not found
              IncExpCategoryAbrev: colorItem?.IncExpCategoryAbrev
            };
          });
  
          setChart(coloredData);
        } catch (e) {
          setChart(processedData); // Fallback to uncolored data in case of an error
        }
      }
    };
  
    processChartDataWithColors();
  }, [classifyButtonIndex, ChartData]);

  useEffect(()=>{
    console.log("chart data: ", chart);
  },[chart]);



  const chartWrapperRef = useRef();

  useEffect(() => {
    // Target only the chart's SVG within this specific wrapper
    const chartSurfaceSVG = document.querySelector(".k-chart-surface svg");
    const chartSurface = document.querySelector(".k-chart-surface")
    if (chartSurfaceSVG) {
      chartSurfaceSVG.style.overflow = "visible";
      chartSurfaceSVG.style.paddingRight ="500px";
    }
  });

  return (
    <>
    <ClasifyButtons selectedIndex={classifyButtonIndex}></ClasifyButtons>
    <div style={{ width: "50%", margin: "0 auto", overflow: "visible" }}>
        <Chart style={{ width: "100%" }} >
        <ChartTooltip
        render={(e) => {
          console.log(e.point)
          return `${e.point?.category} - ${e.point?.value}%`
        }} // Display value as percentage
      />
          <ChartSeries>
            <ChartSeriesItem
              type="donut"
              data={chart}
              categoryField="IncExpCategoryName"
              field="Percentage"
              colorField="IncExpChartColor"
              padding={10}
            >
            </ChartSeriesItem>
          </ChartSeries>
          <ChartLegend
          position="bottom"// Positions the legend below the chart
          visible={true}   // Ensures the legend is visible
          orientation="horizontal"
          labels={{
            content: (e) => {
              // Replace text with the abbreviation from data
              const matchingItem = chart.find(
                (item) => item.IncExpCategoryName === e.text
              );
              return matchingItem?.IncExpCategoryAbrev || e.text;
            },
          }}
        />
        </Chart>
    </div>
    </>
  )
}

export const TimeSeriesChart = ({ ChartData, labelTemplate }) => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const [chart, setChart] = useState(formatChartData(ChartData));
  useEffect(()=>{
 setChart(val=>formatChartData(ChartData));
  },[ChartData]);
  function formatChartData(data) {

    const NetMonthlyTotal = months.map(month => data?.NetMonthlyTotal[month]).reduce((acc, curr, index) => {
      if (index === 0) {
          acc.push(curr); 
      } else {
          acc.push(acc[index - 1] + curr);
      }
      return acc;
  }, []);;
    const TotalExpenses = months.map(month => data?.TotalExpenses[month]);
    const TotalIncome = months.map(month => data?.TotalIncome[month]);
    return {NetMonthlyTotal,TotalExpenses,TotalIncome};
  }
 
  

  return <>
  
  <div className="header-container" style={{width:'595px', height: '35px', marginBottom:'17px'}}>
          <b>
          Time Series
            </b>
          </div>
    <Chart style={{ height: 350, width: 'auto' }}>
    <ChartLegend position="bottom" orientation="horizontal"/>
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                            categories={months}
                            labels={{ rotation: -45 }}
                        />
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                        <ChartValueAxisItem
                            labels={{ format: "c0" }}
                            // min={Math.min(...data.map((item) => item.value)) - 20}
                            // max={Math.max(...data.map((item) => item.value)) + 20}
                            majorGridLines={{ visible: true, color: "#e5e5e5" }}
                        />
                    </ChartValueAxis>
                    <ChartTooltip format="c0" />
                    <ChartSeries>
                        <ChartSeriesItem
                            type="line"
                            data={chart?.TotalExpenses}
                            color="#002c75"
                            opacity={0.6}
                            line={{
                                style: "smooth",
                                width: 2,
                                color: "#002c75",
                            }}
                            markers={{
                                visible: true,
                                size: 6,
                                background: "#002c75",
                            }}
                            name="Total Expenses" 
                           
                        />
                         <ChartSeriesItem
                          name="Net Monthly Total"
                            type="area"
                            data={chart?.NetMonthlyTotal}
                            color="#d2e2fb"
                            opacity={0.6}
                            line={{
                                style: "smooth",
                                width: 2,
                                color: "#d2e2fb",
                            }}
                            markers={{
                                visible: true,
                                size: 6,
                                background: "#d2e2fb",
                            }}
                            gradient={{
                                opacity: 0.5,
                                stops: [
                                    { offset: 0, color: "#d2e2fb", opacity: 0.7 },
                                    { offset: 0.5, color: "#d2e2fb", opacity: 0.5 },
                                    { offset: 1, color: "#d2e2fb", opacity: 0.3 },
                                ],
                            }}
                        />
                         <ChartSeriesItem
                            type="line"
                            data={chart?.TotalIncome}
                            color="#206eec"
                            opacity={1}
                            name="Total Income"
                            line={{
                                style: "smooth",
                                width: 2,
                                color: "#206eec",
                            }}
                            markers={{
                                visible: true,
                                size: 6,
                                background: "#206eec",
                            }}
                          
                        />
                    </ChartSeries>
                </Chart>
  </>
}